//Auxiliary class to manage objects of typed values at a higher level among editors and viewers
angular.module('utils').factory('tgField', function tgFieldFactory(tgConfig) {
	function isEmpty(data) {
		if (_.isString(data) && (data === 'null' || data === 'undefined')) {
			return true
		} else if (_.isUndefined(data) || _.isNull(data) || _.isNaN(data)) {
			return true
		} else if (_.isObject(data) || _.isArray(data) || _.isString(data)) {
			return _.isEmpty(data)
		} else {
			return false
		}
	}

	function toSource(data) {
		/*var text = '';
    data = data || '';
    if (_.isString(data)) {
      text = data;
    } else {
      if (_.isObject(data) && !_.isArray(data)) {
        //force to show undefined properties (excluding functions/prototypes)
        text += '{';
        for (var prop in data) {
          if (!_.isFunction(data[prop])) {
            text += '"' + prop + '":';
            var temp = toString(data[prop]);
            //enclose result in quotes if property is null or not an object
            if (_.isEmpty(temp) || (temp.substring(0, 1) !== '{' && temp.substring(temp.length - 1) !== '}')) {
              temp = '"' + temp + '"';
            }
            text += temp + ',';
          }
        }
        if (text.length > 1) {
          text = text.slice(0, -1);
        }
        text += '}';
      } else {
        //text = JSON.stringify(data);
        var tmp = _(data).value();
        text = _.isObject(tmp) ? angular.toJson(data) : tmp;
      }
    }
    return text;*/
		return angular.toJson(data, true)
	}

	function isJsonString(str) {
		try {
			//JSON.parse(str);
			angular.fromJson(str)
		} catch (e) {
			return false
		}
		return true
	}

	function fromSource(source) {
		var obj
		if (_.isObject(source)) {
			obj = angular.copy(source)
		} else {
			//if (!_.isObject(source))
			var temp = isJsonString(source) ? angular.fromJson(source) : undefined
			if (temp) {
				obj = temp
			} else {
				obj = source
			}
		}
		return obj
	}

	function isUrl(str) {
		return _.isString(str) && (str.substr(0, 7) === 'http://' || str.substr(0, 8) === 'https://')
	}

	function isImageName(str) {
		return (
			_.isString(str) &&
			(str.substr(-4) === '.png' ||
				str.substr(-4) === '.jpg' ||
				str.substr(-5) === '.jpeg' ||
				str.substr(-4) === '.gif')
		)
	}

	function isImageUrl(str) {
		return isUrl(str) && isImageName(str)
	}

	function isImageDataString(str) {
		return _.isString(str) && str.substr(0, 10) === 'data:image'
	}

	function isValidEmail(email) {
		var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
		return re.test(email)
	}

	function isDateString(date) {
		return _.isNumber(Date.parse(date)) && !_.isNaN(Date.parse(date))
	}

	function isDurationString(duration) {
		var d = moment.duration(duration)
		return moment.isDuration(d) && d.asMilliseconds() != 0
	}

	function isGeoPointObject(data) {
		if (_.isObject(data)) {
			return (
				(_.has(data, '__type') && data.__type == 'GeoPoint') ||
				(_.has(data, 'latitude') && _.has(data, 'longitude'))
			)
		} else {
			return false
		}
	}

	function isParseDateObject(data) {
		if (_.isObject(data)) {
			return _.has(data, '__type') && data.__type == 'Date' && _.has(data, 'iso') //&& isDateString(data.iso);
		} else {
			return false
		}
	}

	function isI18nObject(data) {
		if (_.isObject(data)) {
			return _.has(data, tgConfig.preferredLanguage)
		} else {
			return false
		}
	}

	function typeOf(data, property) {
		var type
		if (arguments.length > 1) {
			if (_.isObject(data)) {
				data = data[property]
			}
		}
		if (_.isBoolean(data)) {
			type = 'boolean'
		} else if (isGeoPointObject(data)) {
			type = 'location'
		} else if (isParseDateObject(data)) {
			type = 'date'
		} else if (isI18nObject(data)) {
			type = 'i18n'
		} else if (_.isString(data)) {
			if (isImageName(data) || isImageUrl(data) || isImageDataString(data)) {
				type = 'image'
			} else if (isValidEmail(data)) {
				type = 'email'
			} else if (isUrl(data)) {
				type = 'url'
			} else if (isDateString(data)) {
				type = 'date'
			} else {
				if (data.length > 80) {
					type = 'text-area'
				} else {
					type = 'text'
				}
			}
		} else if (_.isObject(data)) {
			type = 'object'
		}
		if (!type && !!property && _.isString(property)) {
			if (property.substr(-4) === 'Date') {
				type = 'date'
			} else if (property === 'avatarUrl' || property === 'imageUrl') {
				type = 'image'
			} else if (property === 'descript') {
				type = 'i18n'
			}
		}
		return type
	}

	//Same function extended to allow sort by multiple fields:
	function compareBy(_fields, _reverse, _primers) {
		var fieldsArray = []
		var primersArray = []
		if (_fields.constructor === Array) {
			fieldsArray = _fields
		} else {
			fieldsArray.push(_fields) //just a single field
		}
		if (_primers) {
			if (_primers.constructor === Array) {
				if (_primers.length === fieldsArray.length || _primers.length === 1) {
					primersArray = _primers
				} else {
					throw new Error(
						'compareBy(): primers should be [] of the same size of fields[] or one single function.'
					)
				}
			} else {
				primersArray.push(_primers) //just a single function
			}
		}

		var reverse = []
		if (_reverse) {
			if (_reverse.constructor === Array) {
				if (_reverse.length === fieldsArray.length) {
					reverse = _reverse
				} else if (_reverse.length === 1) {
					//replicates single value
					fieldsArray.forEach(function () {
						reverse.push(_reverse[0])
					})
				} else {
					throw new Error(
						'compareBy(): reverse should be [boolean] of the same size of fields[] or one single boolean value.'
					)
				}
			} else {
				//just a single value
				fieldsArray.forEach(function () {
					reverse.push(_reverse)
				})
			}
		}

		var keys = []
		fieldsArray.forEach(function (element, index) {
			keys[index] = primersArray[index]
				? function (x) {
						return primersArray[index](x[element])
				  }
				: primersArray[0]
				? function (x) {
						return primersArray[0](x[element])
				  }
				: function (x) {
						return x[element]
				  }
			reverse[index] = [1, -1][+!!reverse[index]] //forces to be -1 or 1: //[1, -1][+!!_reverse];
		})

		return function (a, b) {
			function helper(_a, _b, _index) {
				if (_index >= fieldsArray.length) {
					return 0
				} else {
					var valA = keys[_index](_a)
					var valB = keys[_index](_b)
					var temp = valA ? (valB ? (valA > valB) - (valB > valA) : 1) : valB ? -1 : 0
					if (temp !== 0) {
						return reverse[_index] * temp
					} else {
						return helper(_a, _b, ++_index)
					}
				}
			}
			return helper(a, b, 0)
		}
	}

	return {
		isEmpty: isEmpty,
		typeOf: typeOf,
		isJsonString: isJsonString,
		toSource: toSource,
		fromSource: fromSource,
		isUrl: isUrl,
		isImageName: isImageName,
		isImageUrl: isImageUrl,
		isImageDataString: isImageDataString,
		isValidEmail: isValidEmail,
		isDateString: isDateString,
		isDurationString: isDurationString,
		isGeoPointObject: isGeoPointObject,
		isParseDateObject: isParseDateObject,
		isI18nObject: isI18nObject,
		compareBy: compareBy,
	}
})
